import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import { getFullName, notify } from "../../../../util/helpers";
import RiskPill from "../../../common/RiskPill";
import "./RiskModal.css";
import { isEmptyObject } from "jquery";
import {
  diagnosisDataPatient,
  updateSelfHarmFlag,
  singlePatientLogic,
  alertFireFlag,
  fetchPatientNotesLogic,
} from "../../../../store/features/patient/patientSlice";
import PatientLoader from "../../../common/PatientLoader";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};
const RiskButton = ({ type, text, isSelected, onClick, answers, id }) => {
  return (
    <div className={`risk-button risk-button${isSelected && "-" + text}`}>
      <input
        onClick={onClick}
        type="radio"
        style={{ width: "7%", height: "7%" }}
        checked={answers[id]?.answer === type}
      />
      <div className="container-fluid">
        <RiskPill
          icon_type="flag"
          icon_height="10px"
          icon_width="10px"
          icon_styles={{ marginRight: "10px" }}
          type={type}
          styles={{ width: "fit-content", margin: "0px", marginBottom: "5px" }}
          custom_text={
            type == "low"
              ? "Low Risk"
              : type == "triage"
              ? "Triage - High Risk"
              : "High Risk"
          }
        />
        <span>{text}</span>
      </div>
    </div>
  );
};
const RiskModal = ({ modalIsOpen, setIsOpen, patientId = null }) => {
  Modal.setAppElement("#root");
  const dispatch = useDispatch();
  const [localLoading, setLocalLoading] = useState(false);
  const [currentFlagData, setCurrentFlagData] = useState({});
  const [currentFlagIndex, setCurrentFlagIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const { user, selectedProvider, selectedClinic } = useSelector(
    (state) => state.app
  );
  const { loading, singlePatientData } = useSelector((state) => state.patient);

  useEffect(() => {
    if (currentFlagIndex < singlePatientData?.fire_flag?.length) {
      setCurrentFlagData(singlePatientData?.fire_flag[currentFlagIndex]);
    }
  }, [currentFlagIndex, modalIsOpen]);

  const handlePagination = (type = "next") => {
    if (type == "prev") {
      if (currentFlagIndex - 1 >= 0) {
        setCurrentFlagIndex(currentFlagIndex - 1);
      }
    } else if (type == "next") {
      if (currentFlagIndex + 1 < singlePatientData?.fire_flag?.length) {
        setCurrentFlagIndex(currentFlagIndex + 1);
      }
    }
  };

  useEffect(() => {
    if (isEmptyObject(singlePatientData) && patientId) {
      setLocalLoading(true);
      if (selectedProvider) {
        const id = patientID;
        const params = {
          clinic_id: selectedClinic?.clinic?.id,
          clinician_id: selectedProvider,
        };
        dispatch(singlePatientLogic({ id, params }));
      } else {
        dispatch(singlePatientLogic({ id: patientID }));
      }
    }
  }, []);

  useEffect(() => {
    if (!loading) {
      setLocalLoading(false);
    }
  }, [loading]);

  function closeModal() {
    if (loading) {
      notify("Please wait while upload is in progress");
      return;
    }
    setAnswers({});
    setIsOpen(false);
  }

  const handleAnswerSelection = (id, answer, reason) => {
    const temp = { ...answers };
    temp[id] = { answer: answer, reason: reason };
    setAnswers(temp);
  };

  const handleSubmit = () => {
    if (isEmptyObject(answers)) {
      notify("No responses to record", "info");
      return;
    }
    if (submitting) {
      notify("Please wait while we record your answers... ", "info");
      return;
    }
    setSubmitting(true);
    Object.entries(answers).map(([key, value]) => {
      const flagType =
        value.answer === "high"
          ? "high"
          : value.answer === "triage"
          ? "Triage - High"
          : "low";
      const journalId = parseInt(key);
      // if (flagType === "low") {
      if (flagType !== "high") {
        updateSelfHarmFlag({ journal_id: journalId })
          .then((res) => {
            if (res.status === 200) {
              dispatch(alertFireFlag(journalId));
            }
          })
          .catch((e) => console.log(e));
      }

      console.log("selectedProvider", selectedProvider);
      console.log("user?.id", user?.id);
      const structure = {
        diagnosis: "Fireflag Detection",
        notes: `Therapist marked fireflag as ${flagType} risk - "created on basis of ${value.reason} assessment response"`,
        //{currentFlagData?.journal_fire_flagged}
        patient: singlePatientData?.id,
        // added_by: selectedProvider ? selectedProvider : user?.id,
        added_by: user?.id ? user?.id : selectedProvider,
      };
      diagnosisDataPatient(structure)
        .then((res) => {
          if (res.status === 201) {
            notify("Your response was recorded!", "success");
            dispatch(
              fetchPatientNotesLogic({
                patient: singlePatientData?.id,
                ordering: "-created",
              })
            );
          }
        })
        .catch((e) => {
          console.log(e);
          notify("We couldn't record your response. Try again later!", "error");
        });
    });
    setSubmitting(false);
    setCurrentFlagIndex(0); // Reset to initial index

    closeModal();
  };
  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>

          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">
                {currentFlagIndex + 1}/{singlePatientData?.fire_flag?.length}
              </h3>
            </div>
            {localLoading ? (
              <PatientLoader />
            ) : (
              <div className="container-fluid my-3">
                <span className="mt-2 mb-4">
                  <strong>{getFullName(singlePatientData)}</strong> has been
                  identified as a potential{" "}
                  <strong style={{ color: "red" }}>urgent risk alert</strong>,
                  which means Rose system has detected{" "}
                  <strong style={{ color: "red" }}>
                    indications of suicidal ideation
                  </strong>
                </span>
                <div className="journal-response-container">
                  <strong>This patient was flagged because: </strong>
                  <span>
                    Our algorithms detected potential suicide ideation in the
                    following journal entry,
                  </span>
                  <i>"{currentFlagData?.journal_fire_flagged}"</i>
                </div>
                <span className="my-3">
                  Using your clinical judgement, please classify this alert as:
                </span>
                <div className="container-fluid mb-3">
                  <RiskButton
                    type="low"
                    text="The patient was flagged unnecessarily, or the data is not of immediate concern."
                    onClick={() => {
                      handleAnswerSelection(
                        currentFlagData?.id,
                        "low",
                        currentFlagData?.journal_fire_flagged
                      );
                    }}
                    id={currentFlagData?.id}
                    answers={answers}
                  />
                  <RiskButton
                    type="triage"
                    text="The patient was at risk of harm, but is being taken care of."
                    onClick={() => {
                      handleAnswerSelection(
                        currentFlagData?.id,
                        "triage",
                        currentFlagData?.journal_fire_flagged
                      );
                    }}
                    id={currentFlagData?.id}
                    answers={answers}
                  />
                  <RiskButton
                    type="high"
                    text="The patient is at risk of harm."
                    onClick={() => {
                      handleAnswerSelection(
                        currentFlagData?.id,
                        "high",
                        currentFlagData?.journal_fire_flagged
                      );
                    }}
                    id={currentFlagData?.id}
                    answers={answers}
                  />
                </div>
                <div className="d-flex justify-content-between container-fluid mt-5">
                  <button
                    className="btn alternative-btn"
                    style={{ padding: "10px 20px !important" }}
                    disabled={loading || currentFlagIndex === 0}
                    onClick={() => {
                      handlePagination("prev");
                    }}
                  >
                    Prev
                  </button>
                  <div className="d-flex" style={{ gap: "5%" }}>
                    <button
                      className="btn alternative-btn"
                      style={{ padding: "10px 20px !important" }}
                      onClick={() => {
                        handlePagination("next");
                      }}
                      disabled={
                        loading ||
                        currentFlagIndex ===
                          singlePatientData?.fire_flag?.length - 1
                      }
                    >
                      Next
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="primary-btn"
                      disabled={loading || submitting || isEmptyObject(answers)}
                      style={{ padding: "10px 20px !important" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default RiskModal;
